<div class="modal p-b-24">
	<div>
		<div class="title">
			<div>Historical Transactions</div>
		</div>
		<div class="sub-title">
			<div>Historical transactions are dated</div>
		</div>

	</div>
	<div class="m-t-24">
		<div class="header-text m-b-10">Download for:</div>
		<div class="date-tabs" nz-row nzJustify="space-between">
			<div *ngFor="let tab of tabs" (click)="selectDateTab(tab)" class="inline-tab"
				 [ngClass]="selectedTab && selectedTab.name === tab.name? 'inline-active-tab' : ''">{{tab.name}}</div>
		</div>
	</div>
	<form [formGroup]="historyDownloadForm" (ngSubmit)="downloadFile()" class="m-t-24">
		<div class="header-text m-b-10">
			Set custom download date:
		</div>
		<div nz-row nzGutter=16>
			<div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12">
				<div class="m-t-8">
					<nz-date-picker formControlName="startDate" [nzDisabledDate]="disabledDate"
									nzPlaceHolder="Start date" [nzSuffixIcon]="calendar">
					</nz-date-picker>
				</div>
			</div>
			<div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12">
				<div class="m-t-8">
					<nz-date-picker formControlName="endDate" [nzDisabledDate]="disabledDate" nzPlaceHolder="End date"
									[nzSuffixIcon]="calendar">
					</nz-date-picker>
				</div>
			</div>
			<ng-template #calendar>
				<svg fill="none" height="20" viewBox="0 0 24 20" width="24" xmlns="http://www.w3.org/2000/svg">
					<path clip-rule="evenodd"
						  d="M18.8766 3.36369H20.974C22.1308 3.36369 23.0714 4.11367 23.0714 5.03402V17.5615C23.0714 18.4827 22.1308 19.2318 20.974 19.2318H2.0974C0.940686 19.2318 0 18.4827 0 17.5615V5.03402C0 4.11367 0.940686 3.36369 2.0974 3.36369H4.19481V5.86918H6.29221V1.69336H8.38962V3.36369H14.6818V5.86918H16.7792V1.69336H18.8766V3.36369ZM3.14629 16.7263H7.3411V13.3857H3.14629V16.7263ZM7.3411 11.7153H3.14629V8.37467H7.3411V11.7153ZM9.43847 16.7263H13.6333V13.3857H9.43847V16.7263ZM13.6333 11.7153H9.43847V8.37467H13.6333V11.7153ZM15.7306 11.7153H19.9254V8.37467H15.7306V11.7153Z"
						  fill="#273D50" fill-opacity="0.249434" fill-rule="evenodd"/>
				</svg>
			</ng-template>
		</div>

		<div class="header-text m-b-10 m-t-24">
			Download format:
		</div>
		<nz-form-item class="custom-moniepoint-select">
			<nz-form-control>
				<nz-select [nzSuffixIcon]="customDropDown" formControlName="fileFormat"
						   name="To which agent wallet outlet?" style="width: 100%;" nzPlaceHolder="Select Format">
					<nz-option *ngFor="let item of format" [nzLabel]="item" [nzValue]="item">
						{{item}}
					</nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>

		<ng-template #customDropDown>
			<svg fill="none" height="8" viewBox="0 0 14 8" width="14" xmlns="http://www.w3.org/2000/svg">
				<path clip-rule="evenodd"
					  d="M13.1363 0.263604C13.4878 0.615076 13.4878 1.18492 13.1363 1.5364L7.7363 6.9364C7.38483 7.28787 6.81498 7.28787 6.46351 6.9364L1.06351 1.5364C0.712035 1.18492 0.712035 0.615075 1.06351 0.263603C1.41498 -0.0878685 1.98483 -0.0878685 2.3363 0.263603L7.0999 5.02721L11.8635 0.263604C12.215 -0.087868 12.7848 -0.087868 13.1363 0.263604Z"
					  fill="black" fill-rule="evenodd"/>
			</svg>
		</ng-template>

		<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>

	</form>
	<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-34">
		<div nz-col class="gutter-row" [nzSpan]="12">
			<button class="btn btn-secondary btn-block"
					(click)="modal.destroy()">{{'moniepoint.cancel'|translate}}</button>
		</div>
		<div nz-col class="gutter-row" [nzSpan]="12">
			<app-custom-submit-button (click)="downloadFile()" [submitting]="submitting" [block]="true"
									  name="{{'moniepoint.download'|translate | titlecase}}">
			</app-custom-submit-button>
		</div>
	</div>
</div>
